import { Description, HeadsetMic, PhotoCameraFront, RemoveRedEye, Search } from "@mui/icons-material"
import { Box, CircularProgress, Menu, MenuItem, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useContext, useEffect, useState } from "react"
import EventosSelectMultiple from "../../Components/EventosSelectMultiple/EventosSelectMultiple"
import AutoCompleteMoradores from "./AutoCompleteMoradores/AutoCompleteMoradores"
import OneButton from "../../Components/OneButton/OneButton"
import OneDatePicker from "../../Components/OneDatePicker/OneDatePicker"
import OneTablePagination from "../../Components/OneTablePagination/OneTablePagination"
import { WebSocketContext } from "../../Providers/WebSocket/WebSocketContext"
import { showNotify } from "../../Utils/Utils"
import { filtrosTypography } from "./SxGestaoEventos"
import VisualizacaoEvento from "./VisualizacaoEvento/VisualizacaoEvento"
import moment from "moment"
import { LoadingPageContext } from "../../Providers/LoadingPage/LoadingPageContext"
import { useAppTheme } from "../../Providers/ThemeContext/ThemeContext"
import ComboBoxGestaoEventos from "./comboBox/ComboBoxGestaoEventos"

const GestaoEventos = () => {
    const tableColumns = [
        {
            name: 'Evento',
            selector: row => <span title={row.descricao}>{row.evento}</span>,
            grow: 0.4
        },
        {
            name: 'Cond. / Empresa',
            selector: row => row.condominio,
            grow: 0.7
        },
        {
            name: 'Data / Hora',
            selector: row => row.dt_criacao,
            grow: 0.7
        },
        {
            name: 'Data Conclusão',
            selector: row => row.dt_fechamento ? row.dt_fechamento : "--",
            grow: 0.7
        },
        {
            name: 'Operador',
            selector: row => row.operador ? row.operador : "--"
        },
        {
            name: 'Usuário / Morador',
            selector: row => row.usuario_morador ? row.usuario_morador : "--"
        },
        {
            name: 'Entrada / Acesso',
            selector: row => row.entrada ? row.entrada : "Sem entrada"
        },
        {
            name: 'Cam',
            cell: (row) => <span><PhotoCameraFront sx={{ cursor: '', color: (row.ids_camera_gravacao ? 'black' : 'grey') }} /></span>,
            button: true
        },
        {
            name: 'Audio',
            cell: (row) => <span><HeadsetMic sx={{ cursor: '', color: (row.ligacao ? 'black' : 'grey') }} /></span>,
            button: true
        },
        {
            name: 'Ver',
            cell: (row) => <RemoveRedEye sx={{ cursor: 'pointer' }} onClick={() => handleViewEvent(row.id)}/>,
            button: true
        }
    ]

    const { sendWs, addRoute } = useContext(WebSocketContext)

    const { LoadingPage } = useContext(LoadingPageContext)

    const { theme } = useAppTheme()

    const [openEvento, setOpenEvento] = useState(false)
    const [idToView, setIdToView] = useState(null)

    const [eventList, setEventList] = useState(null)
    const [listagens, setListagens] = useState(null)
    const [selectedFilters, setSelectedFilters] = useState(null)
    const [loading, setLoading] = useState(true)

    const [loadingTable, setLoadingTable] = useState(false)

    const [totalRows, setTotalRows] = useState(10)
    const [perPage, setPerPage] = useState(10)
    const [page, setPage] = useState(1)

    const getWsResponse = (msg) => {
        if (msg.cmd == "buscarListagens#gestaoEvento") {
            setListagens(msg.data.listagens)
        } else if (msg.cmd == "getGestaoEventos") {
            setEventList(msg.data.eventos.eventos)
            setTotalRows(msg.data.eventos.totalEventos[0].total)
            setSelectedFilters(msg.data.filtros)
        }
        setLoadingTable(false)
    }

    useEffect(() => {
        addRoute("getGestaoEventos", getWsResponse)
        sendWs("getGestaoEventos", { filtros: {}, rgs: perPage, page })
        addRoute("buscarListagens#gestaoEvento", getWsResponse)
        sendWs("buscarListagens#gestaoEvento", {
            listagens: {
                evento: ["id", "evento", "descricao"],
                tag: ["id", "descricao"],
                condominio: ["id_central", "nome"],
                operador: ["id", "nome"]
            }
        })
    }, [])

    useEffect(() => {
        if (eventList && listagens) {
            setLoading(false)
        }
    }, [eventList, listagens])

    const [formData, setFormData] = useState(null)

    let optionsEntrada = listagens?.entrada && formData?.condominio ? ([{ id: '0', descricao: "Todos" }, ...listagens?.entrada]) : [{ id: '0', descricao: "Selecione um condomínio" }]

    useEffect(() => {
        if (formData?.condominio && formData?.condominio != "0") {
            sendWs("buscarListagens#gestaoEvento", {
                listagens: {
                    evento: ["id", "evento", "descricao"],
                    tag: ["id", "descricao"],
                    condominio: ["id_central", "nome"],
                    operador: ["id", "nome"],
                    entrada: [formData.condominio]
                }
            })
        } else {
            optionsEntrada = [{ id: '0', descricao: "Selecione um condomínio" }]
            setSelectedFilters({ ...selectedFilters, entrada: "0" })
            // sendWs("buscarListagens#gestaoEvento", {
            //     listagens: {
            //         evento: ["id", "evento", "descricao"],
            //         tag: ["id", "descricao"],
            //         condominio: ["id_central", "nome"],
            //         operador: ["id", "nome"]
            //     }
            // })
        }
    }, [formData?.condominio])

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const handleFiltroEventos = (newEventos) => {
        setFormData({ ...formData, eventos: newEventos })
    }

    const handleSubmit = () => {
        if (!formData) {
            showNotify("info", "Nenhum filtro selecionado!")
            return
        }
        if (formData.eventos) {
            formData.eventos = formData.eventos.map(evento => evento.evento)
        }
        if (formData.condominio == "0") {
            delete formData.condominio
            delete formData.entrada
        }
        if (formData.entrada == "0") {
            delete formData.entrada
        }
        if (formData.operador == "0") {
            delete formData.operador
        }
        if (formData.tag == "0") {
            delete formData.tag
        }
        if (formData.morador == "") {
            delete formData.morador
        }
        if (formData.condominio) {
            sendWs("buscarListagens#gestaoEvento", {
                listagens: {
                    evento: ["id", "evento", "descricao"],
                    tag: ["id", "descricao"],
                    condominio: ["id_central", "nome"],
                    operador: ["id", "nome"],
                    entrada: [formData.condominio]
                }
            })
        } else {
            sendWs("buscarListagens#gestaoEvento", {
                listagens: {
                    evento: ["id", "evento", "descricao"],
                    tag: ["id", "descricao"],
                    condominio: ["id_central", "nome"],
                    operador: ["id", "nome"]
                }
            })
        }
        setListagens(null)
        setEventList(null)
        setPage(1)
        sendWs("getGestaoEventos", { filtros: formData, rgs: perPage, page })
        setLoading(true)
    }

    const getRelatorio = (msg) => {
        if (msg.data.status) {
            let url
            if (msg.data.filtros.tipoRel == "pdf") {
                url = `${window.location.origin.replace(':3003', '')}/wsOnePortaria/QrToken/relatorios/${msg.data.eventos.split('_')[0]}/${msg.data.eventos}`
            } else {
                url = `${window.location.origin.replace(':3003', '')}/wsOnePortaria/QrToken/relatorios/${msg.data.eventos.split('.')[0]}/${msg.data.eventos}`
            }
            window.open(url, "_blank")
        }
        LoadingPage(false)
    }

    addRoute("relatorioSimples", getRelatorio)
    addRoute("relatorioDetalhado", getRelatorio)

    const gerarRelatorios = (tipo, tipoDoc) => {
        LoadingPage(true)
        if (formData.eventos && typeof formData.eventos[0] !== 'string') {
            formData.eventos = formData.eventos.map(evento => evento.evento)
        }
        if (formData.condominio == "0") {
            delete formData.condominio
            delete formData.entrada
        }
        if (formData.operador == "0") {
            delete formData.operador
        }
        if (formData.tag == "0") {
            delete formData.tag
        }

        formData.tipoRel = tipoDoc
        sendWs(tipo, { filtros: formData })
        // setLoading(true)
    }

    const handlePagination = (newPage) => {
        if (newPage != page) {
            setLoadingTable(true)

            setPage(newPage)
            sendWs("getGestaoEventos", { filtros: selectedFilters || {}, rgs: perPage, page: newPage })
        }
    }

    const handleNewPerPage = (newPerPage, newPage) => {
        if (newPerPage != perPage) {
            setLoadingTable(true)
            setPage(newPage)
            setPerPage(newPerPage)

            sendWs("getGestaoEventos", { filtros: selectedFilters || {}, rgs: newPerPage, page: newPage })
        }
    }

    const handleViewEvent = (id) => {
        setIdToView(id)
        setOpenEvento(true)
    }

    const [relatorioMenu, setRelatorioMenu] = useState(false)
    const openRelatorioMenu = Boolean(relatorioMenu)

    const handleCloseRelatorio = (event) => {
        setRelatorioMenu(false)
    }

    const handleClickRelatorio = (event) => {
        setRelatorioMenu(event.currentTarget)
    }

    return (
        <>
            {!loading
                ? <Grid sx={{ width: '100%', height: '100%', padding: '11px 10px' }}>
                    {openEvento &&
                        <VisualizacaoEvento
                            openEvento={openEvento}
                            setOpenEvento={setOpenEvento}
                            idToView={idToView}
                            setIdToView={setIdToView}
                        />
                    }
                    <form>
                        <Grid xs={12} sx={{ alignItems: 'center' }} container flexDirection={"column"} rowGap={2} >
                            <Grid xs={12} sx={{ alignItems: 'center' }} >
                                <Grid container xs={12} gap={2} >
                                    <Grid lg={1}>
                                        <Typography sx={{ color: 'white', fontWeight: 600 }}>Filtros</Typography>
                                    </Grid>
                                    <Grid lg={4} sm={4} sx={{ alignItems: 'center' }}>
                                        <Grid container xs={12} gap={1}>
                                            <Grid lg={3} marginRight={2}>
                                                <Typography sx={filtrosTypography}>Cond./Empresa: </Typography>
                                            </Grid>
                                            <Grid xs sm md lg>
                                                <ComboBoxGestaoEventos name={"condominio"} options={[{ id_central: '0', nome: 'Todos' }, ...listagens?.condominio]} onChange={handleChange} defaultValue={formData?.condominio || '0'} valor={'id_central'} label={'nome'} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid lg={3} sm={3} sx={{ alignItems: 'center' }}>
                                        <Grid container xs={12} gap={1}>
                                            <Grid lg={3}>
                                                <Typography sx={filtrosTypography}>Tag Atend: </Typography>
                                            </Grid>
                                            <Grid xs sm md lg>
                                                <ComboBoxGestaoEventos name={"tag"} options={[{ id: '0', descricao: 'Todos' }, ...listagens?.tag]} onChange={handleChange} defaultValue={formData?.tag || '0'} valor={'id'} label={'descricao'} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid lg sm sx={{ alignItems: 'center' }}>
                                        <Grid container xs={12} gap={1}>
                                            <Grid lg={2}>
                                                <Typography sx={filtrosTypography}>Morador: </Typography>
                                            </Grid>
                                            <Grid xs sm md lg>
                                                <AutoCompleteMoradores
                                                    key={`${selectedFilters?.morador || "0"}-${selectedFilters?.condominio || "0"}`}
                                                    callback={handleChange}
                                                    defaultValue={selectedFilters?.morador || ''}
                                                    condominio={selectedFilters?.condominio || formData?.condominio || ''}
                                                    disabled={!(formData?.condominio && formData?.condominio != '0')}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid xs={12} sx={{ alignItems: 'center' }} >
                                <Grid container xs={12} gap={2} >
                                    <Grid lg={2.5} sm={3} sx={{ alignItems: 'center' }}>
                                        <Grid container xs={12} gap={1}>
                                            <Grid lg={4.3}>
                                                <Typography sx={filtrosTypography}>Data Inicial: </Typography>
                                            </Grid>
                                            <Grid xs sm md lg>
                                                <OneDatePicker
                                                    name="dt_inicial"
                                                    defaultValue={selectedFilters?.dt_inicial || moment().startOf('day').format('yyyy-MM-DDTHH:mm')}
                                                    callback={handleChange}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid lg={2.5} sm={3} sx={{ alignItems: 'center' }}>
                                        <Grid container xs={12} gap={1}>
                                            <Grid lg={4}>
                                                <Typography sx={filtrosTypography}>Data Final: </Typography>
                                            </Grid>
                                            <Grid xs sm md lg>
                                                <OneDatePicker
                                                    name="dt_final"
                                                    defaultValue={selectedFilters?.dt_final || moment().endOf('day').format('yyyy-MM-DDTHH:mm')}
                                                    callback={handleChange}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid lg sm sx={{ alignItems: 'center' }}>
                                        <Grid container xs={12} gap={1}>
                                            <Grid lg={1}>
                                                <Typography sx={filtrosTypography}>Eventos: </Typography>
                                            </Grid>
                                            <Grid xs sm md lg>
                                                <EventosSelectMultiple
                                                    callback={handleFiltroEventos}
                                                    name={"eventos"}
                                                    label={"descricao"}
                                                    value={"evento"}
                                                    options={listagens?.evento}
                                                    defaultValue={selectedFilters?.eventos || ''}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid xs={12} sx={{ alignItems: 'center' }} >
                                <Grid container xs={12} gap={2} >
                                    <Grid lg={4} sm={5} sx={{ alignItems: 'center' }}>
                                        <Grid container xs={12} gap={1}>
                                            <Grid lg={2}>
                                                <Typography sx={filtrosTypography}>Entrada: </Typography>
                                            </Grid>
                                            <Grid xs sm md lg>
                                                <ComboBoxGestaoEventos key={`${selectedFilters?.entrada || "0"}-${optionsEntrada.length}`} disabled={!(formData?.condominio && formData?.condominio != '0')} name={"entrada"} options={optionsEntrada} onChange={handleChange} defaultValue={selectedFilters?.entrada || "0"} valor={'id'} label={'descricao'} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid lg={4} sm sx={{ alignItems: 'center' }}>
                                        <Grid container xs={12} gap={1}>
                                            <Grid lg={2}>
                                                <Typography sx={filtrosTypography}>Operador: </Typography>
                                            </Grid>
                                            <Grid xs sm md lg>
                                                <ComboBoxGestaoEventos name={"operador"} options={[{ id: '0', nome: "Todos" }, ...listagens?.operador]} onChange={handleChange} defaultValue={selectedFilters?.operador || '0'} valor={'id'} label={'nome'} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid lg sm={2} sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                                        <OneButton
                                            id="button_teste"
                                            color="one_primary"
                                            variant="contained"
                                            IconStart={Description}
                                            onClick={handleClickRelatorio}
                                        >
                                     Relatório
                                        </OneButton>
                                        <Menu
                                            anchorEl={relatorioMenu}
                                            open={openRelatorioMenu}
                                            onClose={handleCloseRelatorio}
                                        >
                                            <MenuItem
                                                onClick={() => {
                                                    gerarRelatorios("relatorioSimples", "PDF")
                                                    setRelatorioMenu(false)
                                                }}
                                            >
                                                {/* <PowerSettingsNew sx={{ marginRight: '5px' }}/> */}
                                    Simples PDF
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() => {
                                                    gerarRelatorios("relatorioSimples", "CSV")
                                                    setRelatorioMenu(false)
                                                }}
                                            >
                                                {/* <PowerSettingsNew sx={{ marginRight: '5px' }}/> */}
                                    Simples CSV
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() => {
                                                    gerarRelatorios("relatorioSimples", "XLSX")
                                                    setRelatorioMenu(false)
                                                }}
                                            >
                                                {/* <PowerSettingsNew sx={{ marginRight: '5px' }}/> */}
                                    Simples XLSX
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() => {
                                                    gerarRelatorios("relatorioDetalhado", "PDF")
                                                    setRelatorioMenu(false)
                                                }}
                                            >
                                                {/* <PowerSettingsNew sx={{ marginRight: '5px' }}/> */}
                                    Detalhado PDF
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() => {
                                                    gerarRelatorios("relatorioDetalhado", "CSV")
                                                    setRelatorioMenu(false)
                                                }}
                                            >
                                                {/* <PowerSettingsNew sx={{ marginRight: '5px' }}/> */}
                                    Detalhado CSV
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() => {
                                                    gerarRelatorios("relatorioDetalhado", "XLSX")
                                                    setRelatorioMenu(false)
                                                }}
                                            >
                                                {/* <PowerSettingsNew sx={{ marginRight: '5px' }}/> */}
                                    Detalhado XLSX
                                            </MenuItem>
                                        </Menu>
                                    </Grid>
                                    <Grid lg sm={2} sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                                        <OneButton
                                            id="button_teste"
                                            color="one_primary"
                                            variant="contained"
                                            IconStart={Search}
                                            onClick={handleSubmit}
                                        >
                                     Pesquisar
                                        </OneButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                    <Grid container xs={12} sx={{
                        margin: '10px 2px',
                        backgroundColor: '#D9D9D9',
                        borderRadius: '5px',
                        display: 'flex',
                        flexGrow: 1,
                        flexBasis: 'auto'
                    }}>
                        <OneTablePagination
                            columns={tableColumns}
                            data={eventList}
                            paginationPerPage={perPage}
                            paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                            paginationComponentOptions={ { rangeSeparatorText: "de", rowsPerPageText: 'Itens por página' } }
                            pagination
                            progressPending={loadingTable}
                            paginationServer
                            paginationTotalRows={totalRows}
                            onChangePage={handlePagination}
                            onChangeRowsPerPage={handleNewPerPage}
                            dobleClickCallback={handleViewEvent}
                        />
                    </Grid>
                </Grid>
                : <Box sx={{ display: 'flex', width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress size={90} sx={{ color: theme.palette.one_primary.main }} />
                </Box>
            }
        </>
    )
}

export default GestaoEventos
